import { Banner } from './banner';

export interface Banners {
    superior: Banner[];
    centro: Banner[];
    derecha: Banner[];
    interstitial: Banner[];
}

export class BannersHelper {
    static create(): Banners {
        return {
            superior: [],
            centro: [],
            derecha: [],
            interstitial: []
        };
    }
}
